import { createFileRoute } from "@tanstack/react-router";
import { IptvAppPage } from "@/components/solutions/IptvAppPage";
import { iptvAppSeo } from "@/lib/page-seo";
import lcpImage from "@/assets/iptv-app/native-player.jpg";

export const Route = createFileRoute("/solutions/iptv-app")({
  loader: ({ location }) => ({ href: location.href }),
  head: ({ loaderData }) => {
    const seo = iptvAppSeo(loaderData?.href ?? "/solutions/iptv-app");
    return {
      ...seo,
      links: [
        { rel: "preload", as: "image", href: lcpImage, fetchPriority: "high" as const },
        ...(seo.links ?? []),
      ],
    };
  },
  component: IptvAppPage,
});
